// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');



//////////////////
// WEBPACK FOOTER
// /opt/wh/whtree/~/core-js/modules/_enum-bug-keys.js
// module id = 629
// module chunks = 0